import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/messaging';
import 'firebase/functions';
import { isLocalhost } from './helpers';
import { Notification as Toast } from 'rsuite';

const config = {
  apiKey: "AIzaSyBJdd-OAKgWD-L8BZmLKpDhGPm9izYEsFc",
  authDomain: "authentication-mtf.firebaseapp.com",
  databaseURL: "https://authentication-mtf-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "authentication-mtf",
  storageBucket: "authentication-mtf.appspot.com",
  messagingSenderId: "663631246050",
  appId: "1:663631246050:web:36053e0ca30b5ea52d24bb",
  measurementId: "G-VQ8DGR8Y0G"
};

// instance of firebase app
const app = firebase.initializeApp(config);

// auth for Facebook and Google
export const auth = app.auth();


export const database = app.database();

export const storage = app.storage();

export const functions = app.functions('us-central1');

export const messaging = firebase.messaging.isSupported()
  ? app.messaging()
  : null;

// if (messaging) {
//   messaging.getToken({
//     vapidKey:
//       'BJ_lFbdq1RmUrKGgv4RD57-9_UstBgLx1EKm3rd2G43WK2qlPfT91e_5WhXJYcEOyfOg_EyfTVnzK_NeMAOT_r8',
//   });
if (messaging) {
  messaging.usePublicVapidKey(
    'BN7YrgunHIBIhIETVOr8kwV2H6KmPeagQxVxLdH3LyVCCnF4XH3IpnOj2n87VEpf2_oN3kdgaECVUyIuQ772Zck'
  );

  // foreground
  messaging.onMessage(({ notification }) => {
    // console.log(data);
    const { title, body } = notification;
    Toast.info({ title, description: body, duration: 0 });
  });
}

if (isLocalhost) {
  functions.useFunctionsEmulator('http://localhost:5001');
}
